import { Dictionary } from 'lodash';

import { EmployeeShortDto } from './client.people.generated';

export enum IndicatorCategory {
  PEOPLE = 'PEOPLE',
  REWARDING = 'REWARDING',
  PERFORMANCE = 'PERFORMANCE',
  DEVELOPMENT = 'DEVELOPMENT',
  CUSTOM = 'CUSTOM',
}

export interface IndicatorByUnitResponse {
  count: number;
  indicator: Indicator;
}

export enum IndicatorCategoryType {
  // People
  VACATION_BALANCE_OVER = 'VACATION_BALANCE_OVER',
  // Rewarding
  NO_SALARY_INCREASE = 'NO_SALARY_INCREASE',
  NO_INCENTIVES_PAID = 'NO_INCENTIVES_PAID',
  // Development
  NO_POSITION_CHANGE = 'NO_POSITION_CHANGE',
  NO_TRAININGS_STARTED = 'NO_TRAININGS_STARTED',
  // Performance
  NO_GOALSETTING_DONE = 'NO_GOALSETTING_DONE',
  PERFORMANCE_SCORE_UNDER = 'PERFORMANCE_SCORE_UNDER',
  STATUS_DISCUSSION_EXPIRES = 'STATUS_DISCUSSION_EXPIRES',
  PERFORMANCE_SCORE_OVER = 'PERFORMANCE_SCORE_OVER',
}

export interface IndicatorConfig {
  titleTranslationLabel: string;
  unitTranslationLabel: string;
  employeeIndicatorInfoTranslationLabel: string;
}

export const IndicatorsConfig: Dictionary<IndicatorConfig> = {
  [IndicatorCategoryType.VACATION_BALANCE_OVER]: {
    titleTranslationLabel: 'vacationBalanceOver',
    unitTranslationLabel: 'days',
    employeeIndicatorInfoTranslationLabel: 'vacationBalanceIs',
  },
  [IndicatorCategoryType.NO_SALARY_INCREASE]: {
    titleTranslationLabel: 'noSalaryIncreaseIn',
    unitTranslationLabel: 'months',
    employeeIndicatorInfoTranslationLabel: 'lastSalaryIncreaseWasOn',
  },
  [IndicatorCategoryType.NO_INCENTIVES_PAID]: {
    titleTranslationLabel: 'noIncentivesPaidIn',
    unitTranslationLabel: 'months',
    employeeIndicatorInfoTranslationLabel: 'lastIncentiveWasPaidOn',
  },
  [IndicatorCategoryType.NO_POSITION_CHANGE]: {
    titleTranslationLabel: 'noPositionChangeIn',
    unitTranslationLabel: 'months',
    employeeIndicatorInfoTranslationLabel: 'lastPositionChangeWasOn',
  },
  [IndicatorCategoryType.NO_TRAININGS_STARTED]: {
    titleTranslationLabel: 'noTrainingStartedIn',
    unitTranslationLabel: 'months',
    employeeIndicatorInfoTranslationLabel: 'lastTrainingWasStartedOn',
  },
  [IndicatorCategoryType.NO_GOALSETTING_DONE]: {
    titleTranslationLabel: 'noGoalSettingDoneIn',
    unitTranslationLabel: 'months',
    employeeIndicatorInfoTranslationLabel: 'lastGoalSetWasOn',
  },
  [IndicatorCategoryType.PERFORMANCE_SCORE_UNDER]: {
    titleTranslationLabel: 'performanceScoreUnder',
    unitTranslationLabel: '',
    employeeIndicatorInfoTranslationLabel: 'lastPerformanceScoreWas',
  },
  [IndicatorCategoryType.STATUS_DISCUSSION_EXPIRES]: {
    titleTranslationLabel: 'statusDiscussionExpiresIn',
    unitTranslationLabel: 'days',
    employeeIndicatorInfoTranslationLabel: 'statusDiscussionExpiresOn',
  },
  [IndicatorCategoryType.PERFORMANCE_SCORE_OVER]: {
    titleTranslationLabel: 'performanceScoreOver',
    unitTranslationLabel: '',
    employeeIndicatorInfoTranslationLabel: 'lastPerformanceScoreWas',
  },
};

export interface Indicator {
  id: number;
  name: string;
  active: boolean;
  category: IndicatorCategory;
  config:
    | {
        [key: string]: string;
      }
    | {};
  createdBy: {
    id: number;
    username: string;
  };
  createdTime: string;
  indicatorType: IndicatorCategoryType;
  group?: {
    condition: 'AND' | 'OR';
    indicators: Indicator[];
  };
}

export interface IndicatorEmployeeInfo {
  employee: EmployeeShortDto;
  [key: string]: unknown;
}

export interface IndicatorDetails {
  indicator: Indicator;
  data: IndicatorEmployeeInfo[];
}
